import { START } from 'pu-data/QuoteSteps';

import {
  numberValidation,
  quantitiesValidation,
} from 'pu-data/Validations';

import DefaultParameters from './DefaultParameters';
import DefaultQuote      from './DefaultQuote';

const state = {
  name: 'PCB Assembly',
  code: 'pcbassembly',
  parameters: DefaultParameters,
  parametersChanged: false,
  quote: DefaultQuote,
  suppliers: ['assembly-us', 'assembly-mx'],
  loading: false,
  showSummary: false,
  itemSelected: false,
  errors: {},
  quoteStep: START,
  currentVariant: null,
};

export const validateParametersRules = {
  bom_line_items: (name) => numberValidation('Bom Line Items', name),
  smt: (name) => numberValidation('SMT', name),
  thru_hole: (name) => numberValidation('Thru-Hole', name),
  bga: (name) => numberValidation('BGA', name),
  qfn: (name) => numberValidation('QFN', name),
};

export const aditionalRules = {
  quantities: quantitiesValidation,
  // placements: placementsValidation,
};

export default state;
